export const FIELD_PLACEHOLDER_REGEX = /\{\{\s*field\s*:\s*\d+\s*\}\}/g;
